import { useDataProvider, useNotify, useRecordContext, useRefresh, useResourceContext, useUpdate } from 'react-admin';
import CraftDeleteButtonWithConfirmation from 'src/components/CraftDeleteButtonWithConfirmation';

const DeleteButton = () => {
  const notify = useNotify();
  const refresh = useRefresh();
  const record = useRecordContext();
  const resource = useResourceContext();
  const dataProvider = useDataProvider();

  const [update, { isLoading }] = useUpdate();

  const handleDelete = async () => {
    if (!record) return;
    try {
      try {
        const res = await dataProvider.getList('users_programs', {
          sort: { field: 'created_at', order: 'DESC' },
          filter: { 'program_id@_eq': record.id },
          meta: { noLimit: true },
        });

        const ids = res.data.map((r) => r.id);
        if (ids.length > 0) {
          try {
            await dataProvider.deleteMany('users_programs', { ids });
          } catch (_e) {
            await Promise.allSettled(ids.map((id) => dataProvider.delete('users_programs', { id })));
          }
        }
      } catch (e) {
        console.error('Error deleting users_programs', e);
      }

      await update(
        resource,
        { id: record.id, data: { deleted_at: new Date().toISOString() } },
        { returnPromise: true },
      );
      notify('The item has been successfully deleted', { type: 'success' });
      refresh();
    } catch (e) {
      notify('There was a problem deleting the item. Please try again.', { type: 'error' });
    }
  };

  return (
    <CraftDeleteButtonWithConfirmation
      onDelete={handleDelete}
      loading={isLoading}
      title={`Delete program${record?.name ? ` "${record.name}"` : ''}`}
      content="Are you sure you want to delete this program?"
    />
  );
};

export default DeleteButton;
